import { render, staticRenderFns } from "./MobileStatsDisplay.vue?vue&type=template&id=dea69614&scoped=true"
import script from "./MobileStatsDisplay.vue?vue&type=script&lang=js"
export * from "./MobileStatsDisplay.vue?vue&type=script&lang=js"
import style0 from "./MobileStatsDisplay.vue?vue&type=style&index=0&id=dea69614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea69614",
  null
  
)

export default component.exports